import { useState } from "react";
import api from "@/lib/api";
import { PlayCircle, SpinnerGap } from "@phosphor-icons/react";

export default function DemoButton({ className = "", label = "View live demo" }) {
  const [loading, setLoading] = useState(false);
  const go = async () => {
    setLoading(true);
    try {
      await api.post("/public/demo-login");
      window.location.href = "/app";
    } catch {
      setLoading(false);
    }
  };
  return (
    <button data-testid="demo-login-btn" onClick={go} disabled={loading}
      className={className || "inline-flex items-center gap-2 px-6 py-3.5 border border-zinc-300 rounded-md font-semibold hover:border-black transition-colors active:scale-95 disabled:opacity-60"}>
      {loading ? <SpinnerGap size={18} className="animate-spin" /> : <PlayCircle size={18} weight="fill" className="text-[#1F6FE5]" />}
      {loading ? "Opening demo…" : label}
    </button>
  );
}
